<div class="Flex--col Statistikmonitor" style="height:100%">

    <div class="Card hide-on-print" style="padding:15px;display:flex;align-items: center;flex-grow:0;min-height:100px">
     
            <div class="InputGroup">
                <SmartButton class="Button Input" v-model="mode" set="tabelle">Auswahl nach<br />Raumeinheit (Tabelle)</SmartButton>
                <SmartButton class="Button Input" v-model="mode" set="grafik">Auswahl nach<br />Indikator (Grafik)</SmartButton>
            </div>
            <div style="margin-left:15px">
                Im Modul "Auswahl nach Raumeinheit" werden für jeweils eine Raumeinheit alle Indikatoren in einem Tabellenblatt zusammengefasst.<br />

                Im Modul "Auswahl nach Indikator" erfolgt die Darstellung der Werte für jeweils einen Indikator in grafischer Form.
            </div>
       
        
    </div>

    <div style="flex-grow:1;">
        <StrukturGrafik v-if="mode=='grafik'" style="height:100%" />
        <StrukturTabelle v-if="mode=='tabelle'" style="height:100%" />
    </div>

</div>